import React from 'react';

export default function GoatEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="36.11,29.32 32.55,30.79 25.19,13.02 28.75,11.55" fill="#E6DBE6" />
      <polygon points="32.55,30.79 36.11,29.32 33.8,28.17 30.25,29.64" fill="#BC9EBC" opacity="0.95" />
      <polygon points="32.55,30.79 30.25,29.64 22.88,11.86 25.19,13.02" fill="#BC9EBC" opacity="0.95" />
      <polygon points="9.18,30.79 5.62,29.32 12.98,11.55 16.54,13.02" fill="#E6DBE6" />
      <polygon points="5.62,29.32 9.18,30.79 6.87,29.64 3.31,28.17" fill="#BC9EBC" opacity="0.95" />
      <polygon points="5.62,29.32 3.31,28.17 10.68,10.39 12.98,11.55" fill="#BC9EBC" opacity="0.95" />
      <polygon points="37.78,28.64 33.74,26.62 27.12,10.62 31.16,12.64" fill="#BC9EBC" opacity="0.95" />
      <polygon points="6.26,28.64 2.22,26.62 8.84,10.62 12.88,12.64" fill="#BC9EBC" opacity="0.95" />
      <polygon points="38.0,31.67 33.96,29.65 25.13,8.33 29.17,10.35" fill="#BC9EBC" opacity="0.95" />
      <polygon points="38.0,31.67 33.96,29.65 25.13,8.33 29.17,10.35" fill="#BC9EBC" opacity="0.95" />
      <polygon points="6.04,31.67 2.0,29.65 10.83,8.33 14.87,10.35" fill="#BC9EBC" opacity="0.95" />
      <polygon points="6.04,31.67 2.0,29.65 10.83,8.33 14.87,10.35" fill="#BC9EBC" opacity="0.95" />
    </svg>
  );
}
